import $ from 'jquery';
import Backbone from 'backbone';
import componentize from '../../utils/componentize';
import generateUrl from '../../utils/generate_url_with_slide_util';
import ads from '../../services/admanager';
// import analytics from '../../services/analytics_service';
const slick = require('slick-carousel'); // eslint-disable-line no-unused-vars
import {debounce} from 'underscore';

let initializedForFirstSlideShow = false;

// http://stackoverflow.com/questions/21271112/how-to-implement-omniture-custom-link-tracking-for-on-click-event
// this is used from our old code base
// slot-fastcompany/sites/all/static/public/embed/playerwrapper.js
function trackOmniture(sEvent, sValue) {
    if (!window.fastco_s) {
        // console.error('Omniture not initialized, please include omniture s_code.js');
        return;
    }

    if (!sEvent || !sValue) {
        // console.error('Tracking parameters not provided');
        return;
    }

    //sEvent needs to be in proper format, example event24 where 24 is the number corresponding to event set up in Omniture reporting
    window.fastco_s.linkTrackVars = 'events';
    window.fastco_s.linkTrackEvents = sEvent;
    window.fastco_s.events = sEvent;
    window.fastco_s.tl(this, 'o', sValue);
}

export default function (query, updateAfterClick, slideIndex = 1) {
    return componentize({
        query: query,
        attachedCallback: function () {
            const $this = $(this);
            this.$el = $this;

            // these are default settings that all of our carousels tend to use
            let slickConfig = {
                prevArrow: '<button type="button" class="slick-prev"><i class="icon-arrow"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow"></i></button>'
            };

            // this is s a sign that it's a legacy carousel
            if ($this.find('.slide').length) {
                slickConfig.slide = '.slide';
                slickConfig.asNavFor = '.caption-list[data-title="' + $this.data('title') + '"]';
            }

            // Make sure the iframe is from youtube
            $this.find('iframe')
                .each(function fixIframes(index, el) {
                    const currIndex = index + 1;
                    var $el = $(el);
                    var src = $el.attr('src');
                    if (src.indexOf('ytube') !== -1 || src.indexOf('youtu.be') !== -1 || src.indexOf('youtube') !== -1) {
                        // might be able to remove this, but need to qa
                        $el.attr('height', '100%');
                        $el.attr('width', '100%');
                        // check to see if ln36 is
                        $el.attr('data-orig-src', src);
                        if (currIndex !== Number(slideIndex)) {
                            $el.attr('src', 'about:blank');
                        }
                    }
                });

            // caption carousel is linked to slideshow by data-title
            if ($this.find('.caption').length) {
                slickConfig.slide = '.caption';
                slickConfig.arrows = false;
                slickConfig.asNavFor = '.slide-list[data-title="' + $this.data('title') + '"]';
                slickConfig.fade = true;
            } else {
                $this.on('afterChange', this.afterClick);
                $this.on('beforeChange', this.beforeChange.bind(this));
            }

            //  ==== EVENT LISTENERS ===
            //  need to wait for the slideshow to finish initiailzation before assigning image orientations
            $this.on('init', this.initializeCallback);
            // this.checkForAndPlayVid(null, null, 0);
            window.addEventListener('resize', debounce(this.onWindowResize.bind(this), 200));
            //  =======================

            // Communicate with admanager to perform ad refreshing job for carousel events (assuming ad refreshing is only done for the pages with caruosel)
            // TODO: for some reason caruosel is initialized twice (basically postController() is called twice); as changing that is out of our scope, making sure it's only done once here
            if (!initializedForFirstSlideShow) {
                initializedForFirstSlideShow = true;
                let adManager = ads();
                if (adManager) {
                    $this.on('afterChange', adManager.triggerUserEventRefresh.bind(adManager));
                }
            }

            this.initializeCarousel(slickConfig);
        },
        onWindowResize: function () {
            // seems like a bug, but we need to reinitialize the carousel if it's been unslicked
            this.initializeCarousel();
        },
        initializeCarousel: function (slickConfig) {
            const $this = this.$el;
            // only initialize the carousel if it hasn't been initialized or destroyed yet
            if (!$this.hasClass('slick-initialized')) {
                $this.find('.slide').removeClass('slick-disabled');
                // TODO: check if inline else run this
                if (slideIndex) {
                    slickConfig.initialSlide = (slideIndex - 1);
                    // check to make sure that the url has the slide index
                    // if not push to 1
                    // Backbone.history.navigate('3049743/creative-conversations/slideshow-inline-dummy-article/' + (Number(currentSlideIndex) + 1));
                }
                $this.slick(slickConfig);
            }
        },

        initializeCallback: function () {
            const $this = this.$el;
            const $media = $this.find('img, video, iframe');

            this.assignMediaTypesAndOrientations($media);
        },

        assignMediaTypesAndOrientations: function ($media) {
            const $this = this.$el;
            const parentAspect = $this.width() / $this.height();

            function assignOrientations(mediaItem, width, height) {
                let aspect = width / height;
                // prevent image from stretching larger than natural dimensions
                mediaItem.style.maxWidth = `${width.toString()}px`;
                mediaItem.style.maxHeight = `${height.toString()}px`;

                if (height >= width || aspect < parentAspect) {
                    // is it a portrait-oriented mediaItem, or is the aspect ratio less than the parent container's aspect ratio?
                    // if so, the height should be set to 100%, and the width should be auto
                    mediaItem.classList.add('full_height');
                } else if (aspect === parentAspect) {
                    // does the mediaItem match the aspect ratio of the parent?
                    // if so, the width is set to 100%, and the position is set to static
                    // (don't need to position absolutely in the center since it takes up the whole space of the parent)
                    mediaItem.classList.add('natural');
                } else if (height < width) {
                    // is it a landscape-oriented mediaItem that doesn't have the same aspect ratio as its parent?
                    // if so, the width should be set to 100%, and the height should be auto
                    mediaItem.classList.add('full_width');
                }
            }

            $media.each(function (index, mediaItem) {
                // mediaItem.style.opacity = 0;
                if (mediaItem.matches('video')) {
                    // wait for the video to load before trying to determine width and height
                    // see http://stackoverflow.com/questions/4129102/html5-video-dimensions
                    mediaItem.onloadedmetadata = function () {
                        let width = this.videoWidth;
                        let height = this.videoHeight;
                        assignOrientations(mediaItem, width, height);
                    };

                    if (index === $media.length - 1) {
                        this.checkForAndPlayVid(null, null, 0);
                    }
                } else {
                    // we need to checkthe image's natural dimensions (not the rendered dimensions)
                    // to avoid a bug where the image's max width or height is set to 0
                    // we can do that by creating a JS Image object and setting its src...
                    // without ever having to actually render it
                    let naturalImg = new Image();

                    if (mediaItem.src) {
                        // on first load, mediaItems don't have src yet, it is data-lazy attr. if that's the case,
                        // we need to set the natural images src to that data attr
                        naturalImg.src = mediaItem.src;
                    } else {
                        naturalImg.src = mediaItem.dataset.lazy;
                    }

                    // wait for the image to load before trying to measure its width and height
                    naturalImg.onload = function () {
                        let width = this.width;
                        let height = this.height;

                        assignOrientations(mediaItem, width, height);
                    };
                }
            }.bind(this));
        },

        checkForAndPlayVid: function (event, slickObj, currentSlideIndex) { // eslint-disable-line no-shadow
            // exclude caption slideshows, they don't have class slide on their slides
            let allSlides = this.querySelectorAll('.slide');

            if (allSlides.length) {
                let currentSlide = allSlides[currentSlideIndex];
                let nextSlide = allSlides[currentSlideIndex + 1];
                let currentVideo = currentSlide.querySelector('video');
                let nextVideo = nextSlide.querySelector('video');

                // pause the current video if there is one
                if (currentVideo) {
                    currentVideo.pause();
                }

                // play the video on the next slide if there is one
                if (nextVideo) {
                    nextVideo.play();
                }
            }
        },

        afterClick: function (event, slickObj, currentSlideIndex) {
            const $media = this.$el.find('img, video, iframe');
            this.updateUrl(currentSlideIndex);
            this.assignMediaTypesAndOrientations($media);
            this.checkForAndPlayVid.apply(this, [event, slickObj, currentSlideIndex]);
            // // Emit analytic trackers for slideshow slide event.
            // analytics.onSlideshowRefresh();
        },

        // make sure the slide iframe is from youtube
        beforeChange: function (event, slickObj, currentSlide, nextSlide) {
            if (updateAfterClick === true) {
                const trackCurrent = currentSlide + 1;
                if (currentSlide !== undefined && nextSlide !== undefined) {
                    if (currentSlide === 0 && (currentSlide - nextSlide < -1)) {
                        trackOmniture('event30', trackCurrent);
                    } else {
                        if ((currentSlide - nextSlide > 1)) {
                            trackOmniture('event29', trackCurrent);
                        }
                        if (nextSlide - currentSlide < 0 && Math.abs(nextSlide - currentSlide) === 1) {
                            trackOmniture('event30', trackCurrent);
                        }
                        if (nextSlide - currentSlide > 0 && Math.abs(nextSlide - currentSlide) === 1) {
                            trackOmniture('event29', trackCurrent);
                        }
                    }
                }
            }

            let allSlides = this.$el.find('.slide');
            if (allSlides.length) {
                let currentSlideEl = allSlides[currentSlide + 1];
                let nextSlideEl = allSlides[nextSlide + 1];
                const $currentSlide = $(currentSlideEl);
                const $nextSlide = $(nextSlideEl);
                const $iframeCurrent = $currentSlide.find('iframe');
                const $iframeNext = $nextSlide.find('iframe');
                const src = $iframeNext.attr('data-orig-src');
                if (src) {
                    $iframeCurrent.attr('src', 'about:blank');
                    $iframeNext.attr('src', src);
                }
            }
        },
        updateUrl: function (currentSlideIndex) {
            if (updateAfterClick) {
                let originalUrl = window.location.pathname;
                Backbone.history.navigate(generateUrl(originalUrl, currentSlideIndex));
            }
        }
    });
}
